import React from 'react'
import Header from '../common/Header'
import HeroCarousel from '../sections/HeroCarousel'
import DestinationsSection from '../sections/DestinationsSection'
import Footer from '../common/Footer'

const HomePage = () => {
    return (
        <>
            <Header />
            <HeroCarousel />
            <DestinationsSection />
            <Footer />
        </>
    )
}

export default HomePage